import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignContentParams from './CampaignContentParams';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedCampaignContentParams = connect(
  mapStateToProps, null,
)(CampaignContentParams);

export default withTranslation(['administration'])(ConnectedCampaignContentParams as any);
